import React, { useEffect, useState } from "react";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const OfferFormTable = () => {
  const [offers, setOffers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const rowsPerPage = 10; // must match backend limit
  const token = sessionStorage.getItem("authToken");

  const fetchOffers = async (page = 1) => {
    try {
      const res = await axios.get(
        `${COMMON_API}/loan/offerForm?page=${page}&limit=${rowsPerPage}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
  
      setOffers(res.data.loan || []);
      setTotalPages(res.data.pagination.totalPages || 1);
      setTotalRecords(res.data.pagination.total || 0);
      setCurrentPage(res.data.pagination.page || 1);
    } catch (err) {
      console.error("Error fetching offers:", err);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  useEffect(() => {
    fetchOffers(currentPage);
  }, [currentPage]);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Offer Form Submissions</h2>
        <p className="text-sm text-gray-600 mb-3">Total Records: {totalRecords}</p>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 text-sm">
            <thead className="bg-gray-200">
              <tr>
                <th className="border border-gray-300 px-4 py-2">ID</th>
                <th className="border border-gray-300 px-4 py-2">Name</th>
                <th className="border border-gray-300 px-4 py-2">Phone</th>
                <th className="border border-gray-300 px-4 py-2">Loan Name</th>
                <th className="border border-gray-300 px-4 py-2">Employment Type</th>
                <th className="border border-gray-300 px-4 py-2">Entity Type</th>
                <th className="border border-gray-300 px-4 py-2">Created At</th>
              </tr>
            </thead>
            <tbody>
              {offers.map((row) => (
                <tr key={row.id} className="hover:bg-gray-50">
                  <td className="border px-4 py-2">{row.id}</td>
                  <td className="border px-4 py-2">{row.name || "-"}</td>
                  <td className="border px-4 py-2">{row.phoneno || "-"}</td>
                  <td className="border px-4 py-2">{row.loan_name || "-"}</td>
                  <td className="border px-4 py-2">{row.employment_type || "-"}</td>
                  <td className="border px-4 py-2">{row.entity_type || "-"}</td>
                  <td className="border px-4 py-2">{formatDate(row.createAt)}</td>
                </tr>
              ))}
              {offers.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center py-3 text-gray-500">
                    No submissions found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center mt-4 space-x-2">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
              className={`px-3 py-1 rounded border ${
                currentPage === 1
                  ? "bg-gray-200 cursor-not-allowed"
                  : "bg-blue-500 text-white"
              }`}
            >
              Prev
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                onClick={() => setCurrentPage(index + 1)}
                className={`px-3 py-1 rounded border ${
                  currentPage === index + 1
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100"
                }`}
              >
                {index + 1}
              </button>
            ))}

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
              className={`px-3 py-1 rounded border ${
                currentPage === totalPages
                  ? "bg-gray-200 cursor-not-allowed"
                  : "bg-blue-500 text-white"
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OfferFormTable;
